import { request } from "../../api";

export type StorageProvider = "aws" | "gcs" | "azure" | "s3";

export type StorageConfig = {
  provider: StorageProvider | "";
  bucket: string;
  region?: string;
  endpoint?: string;
  account?: string;
  forcePathStyle: boolean;
  useRole: boolean;
  hasCredential: boolean;
  configured: boolean;
  source: "saved" | "deployment" | "install" | "";
  installBucket?: string;
  configuredAt?: string;
};

export type StorageConfigInput = {
  provider: StorageProvider;
  bucket: string;
  region?: string;
  endpoint?: string;
  account?: string;
  forcePathStyle?: boolean;
  useRole?: boolean;
  accessKey?: string;
  secretKey?: string;
};

export const storageAdminKeys = { config: ["admin", "storage"] as const };

export const storageAdminApi = {
  config: () => request<StorageConfig>("/v1/admin/storage/config"),
  save: (body: StorageConfigInput) => request<StorageConfig>("/v1/admin/storage/config", { method: "PUT", body }),
  test: (body: StorageConfigInput) => request<{ ok: true }>("/v1/admin/storage/test", { method: "POST", body }),
};
